import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import baemingoLogo from '../../../../Assets/Logos/baemingo_logo_white.svg';
import LanguageSwitch from './LanguageSwitch';
import { glassSurfaceCss } from '../../Components/GlassPill/glassSurface';

/**
 * A thin frosted strip along the bottom edge, full width - the same glass as
 * the service-type cards above it: language switch on the left, "Baemingo" on
 * the right. Deliberately small - it is furniture, not content.
 */
const Bar = styled.footer`
  flex: 0 0 auto;
  width: 100%;
  height: 64px;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid rgba(255, 255, 255, 0.35);
  ${glassSurfaceCss}
`;

const Logo = styled.img`
  height: 16px;
  opacity: 0.8;
`;

const BottomBar: FC = () => (
  <Bar data-testid="epos-bottom-bar">
    <Logo src={baemingoLogo} alt="Baemingo" />
    <LanguageSwitch />
  </Bar>
);

export default memo(BottomBar);
